import { render } from "./ProfilePageMenu.vue?vue&type=template&id=6377ac99"
import script from "./ProfilePageMenu.vue?vue&type=script&lang=js"
export * from "./ProfilePageMenu.vue?vue&type=script&lang=js"

import "./ProfilePageMenu.vue?vue&type=style&index=0&id=6377ac99&lang=css"

import exportComponent from "/Users/nika/Sites/tanastsoroba-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__